import type { AccentHue } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import type { JSX, ParentProps } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Icon } from "@/designSystem/components/icon"
import { ResponsiveContainer } from "@/designSystem/components/responsive-container"
import { Text } from "@/designSystem/components/text"
import { childrenClass, sectionRecipe, titleClass } from "./section.css"

type Props = ParentProps & {
  title: string | JSX.Element
  description: string
  iconName: IconName
  hue: AccentHue
  direction?: "row" | "column"
  id?: string
}
export function Section(props: Props) {
  return (
    <ResponsiveContainer>
      <div
        class={sectionRecipe({ direction: props.direction ?? "row" })}
        id={props.id}
      >
        <div class={titleClass}>
          <Icon name={props.iconName} color="sand800" size="32" />
          <Box alignItems="flex-start">
            <Text
              fontSize="h2"
              color="sand900"
              fontWeight="600"
              fontFamily="serif"
            >
              {props.title}
            </Text>
            <Text color="sand700" fontSize="s">
              {props.description}
            </Text>
          </Box>
        </div>
        <div class={childrenClass}>{props.children}</div>
      </div>
    </ResponsiveContainer>
  )
}
